import { FormCheckboxField, FormDateField, FormField, FormInfoSection, FormListField, FormTextarea } from '#components'
// import type { FormQuestion } from '#types'
import * as yup from 'yup'

export function generateFormSchema(questions: FormQuestion[]) {
  if (!yup) throw new Error('Yup not found')

  if (!questions) {
    console.error('No questions found')
    return yup.object()
  }

  const schemaFields: Record<string, yup.AnySchema> = {}

  questions
    // Exclude InfoText questions, since they're not really inputs
    .filter(question => question.questionType !== QuestionType.InfoSection)
    .forEach((question) => {
      let field: yup.AnySchema

      switch (question.questionType) {
        case QuestionType.Text:
          field = yup.string()
          if (!question.longAnswer) {
          // @ts-ignore
            field = field.max(255) // TODO: fix max
          }
          break

        case QuestionType.MultipleChoice:
          field = yup.string().oneOf(question.options || [])
          break

        case QuestionType.Date:
          field = yup.date()
          break

        case QuestionType.Number:
          field = yup.number()
          break

        case QuestionType.Checkbox:
          field = yup.boolean()
          break

        case QuestionType.Email:
          field = yup.string().email()
          break

        case QuestionType.Url:
          field = yup.string().url()
          break

        case QuestionType.Phone:
          field = yup.string().matches(
            /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/,
            'Invalid phone number',
          )
          break

        default:
          field = yup.string()
      }

      if (question.required) {
        field = field.required()
      }

      // Somehow this doesn't work well with id/numbers, so prepend with question_
      schemaFields[`question_${question.id}`] = field.label(question.text)
    })

  return yup.object().shape(schemaFields)
}

export function getFormQuestionComponent(question: FormQuestion) {
  switch (question.questionType) {
    case QuestionType.InfoSection:
      return FormInfoSection
    case QuestionType.MultipleChoice:
      return FormListField
    case QuestionType.Checkbox:
      return FormCheckboxField
    case QuestionType.Text:
      return question.longAnswer ? FormTextarea : FormField
    case QuestionType.Date:
      return FormDateField
    case QuestionType.Email:
      return FormField // With email type
    case QuestionType.Phone:
      return FormField // With tel type
    case QuestionType.Url:
      return FormField // With url type
    default:
      return FormField
  }
}
